import { memo } from 'react';

import type { RelevancyCardProps } from '../DynamicCardComponent';

import SandEComponent from './SandEComponent';

import { useArticleLinkRule } from '@hooks/useLinkRule';

const trackingData = {
  name: 'Quiz Arena',
  category: 'sponsored card',
};

const fallbackImg = `${window.imgBaseUrl}/imgml/uefacom/${window.competitionFolder}/fallback.jpg`;

export const QuizComponent = (props: RelevancyCardProps) => {
  const { item } = props;
  const href = useArticleLinkRule(item?.teaser?.id);

  return (
    <SandEComponent
      {...props}
      cardType='quizarena'
      buttonTag='quizarena-card-cta'
      fetchArticle={false}
      logoByLanguage
      url={href}
      fallbackImg={fallbackImg}
      trackingData={trackingData}
    />
  );
};

export default memo(QuizComponent);
